import React from 'react';
import './CurrentWeather.scss';
import '../../assets/weather/weather-icons.scss';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// eslint-disable-next-line import/no-cycle
import WeatherIcon from './WeatherIcon';

type Props = {
  currentTemp: number,
  humidity: number,
  weather?: string,
  showC?: boolean,
  code: number,
  city: string
};

const CurrentWeather = (props: Props) => {
  const { currentTemp, humidity, weather, showC, code, city } = props;
  const textC = showC ? 'C' : null;

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      className="current-weather"
    >
      <Grid item className="text-align-center" xs={6}>
        <WeatherIcon code={code} />
        {weather !== null && (
          <Typography
            variant="h6"
            color="inherit"
            classes={{
              root: classNames('text-transform-uppercase white-space-nowrap')
            }}
          >
            {weather}
          </Typography>
        )}
      </Grid>
      <Grid item xs={6}>
        <Typography
          variant="display3"
          color="inherit"
          classes={{
            root: classNames('text-align-right')
          }}
        >
          {Math.round(currentTemp)}°{textC}
        </Typography>
        {humidity !== null && (
          <Typography
            variant="title"
            color="inherit"
            classes={{
              root: classNames('heading humidity-title')
            }}
          >
            Humidity:&ensp;
            {humidity}%
          </Typography>
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="display3"
          color="inherit"
          classes={{
            root: classNames('text-align-right city-name')
          }}
        >
          {city}
        </Typography>
      </Grid>
    </Grid>
  );
};

CurrentWeather.defaultProps = {
  weather: null,
  showC: true
};

export default CurrentWeather;
